import {Injectable} from '@angular/core';
import {TableColumnsDto} from '../../dto/table/table-columns-dto';
import {HttpClient} from '@angular/common/http';
import {TableSearchFilterDataDto} from '../../dto/table/table-search-filter-data-dto';
import {ExpenseTableDto} from '../../dto/expense/expense-table-dto';
import {TaskListDto} from '../../dto/dashboard/task-list-dto';
import {InfoCardsDto} from '../../dto/dashboard/info-cards-dto';
import {ChartDto} from '../../dto/dashboard/chart-dto';
import {NotificationDto} from '../../dto/dashboard/notification-dto';
import {ApiEndPoint} from '../../utility/api-end-point';
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {DropdownDto} from "../../dto/common/dropDown/dropdown-dto";
import {CommonUtility} from "../../utility/common-utility";
import {map} from "rxjs/operators";
import {BehaviorSubject, from, of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  public commonUtil = new CommonUtility();

  constructor(public httpClient: HttpClient) {
  }

  public supportDialogRef: DynamicDialogRef;
  public supportTableList = new BehaviorSubject(null);

  /**
   * Convert objects into forms
   */
  getFormData(object) {
    const formData = new FormData();
    for (const key in object) {
      this.commonUtil.appendFormData(formData, key, object[key]);
    }
    return formData;
  }


  /**
   * get Linear chart data
   */
  getLineChartData() {
    return this.httpClient.get<ChartDto>(ApiEndPoint.API_URL + '/vendor_portal/sec_get_chart_info', {observe: 'response'});
  }

  /**
   * Get Bar chart data
   */
  getBarData() {
    return this.httpClient.get<ChartDto>(ApiEndPoint.API_URL + '/vendor_portal/sec_get_bar_chart_info', {observe: 'response'});
  }

  /**
   * Delete Notification
   */
  deleteNotifications(tenantId, notificationId) {
    return this.httpClient.put(ApiEndPoint.API_URL + '/message_service/sec_mark_notification_as_closed', {},
      {
        params: {tenantId, notificationId},
        observe: 'response'
      });
  }

  /**
   * Mark as read Notification
   */
  markAsReadNotifications(tenantId, notificationId) {
    return this.httpClient.put(ApiEndPoint.API_URL + '/message_service/sec_mark_notification_as_read', {},
      {
        params: {tenantId, notificationId},
        observe: 'response'
      });
  }

  getUserNotificationList(tenantId, userId) {
    return this.httpClient.get(ApiEndPoint.API_URL + '/message_service/sec_get_available_notifications',
      {params: {tenantId, userId}, observe: 'response'});
  }

  getReferenceStatus(documentType, documentId) {
    return this.httpClient.get(ApiEndPoint.API_URL + '/vendor_portal/sec_get_reference_status',
      {params: {documentType, documentId}, observe: 'response'});
  }

  /**
   * Clear all Notification
   */
  clearAllNotifications(tenantId) {
    return this.httpClient.put(ApiEndPoint.API_URL + '/message_service/sec_mark_all_notification_as_closed', {},
      {
        params: {tenantId},
        observe: 'response'
      });
  }

  /**
   * Get to do List
   */
  getToDoList() {
    return this.httpClient.get<TaskListDto[]>(ApiEndPoint.API_URL + '/common_service/sec_get_system_task_list', {observe: 'response'});
  }

  /**
   * Get card list
   */
  getCardList() {
    return this.httpClient.get<TaskListDto[]>(ApiEndPoint.API_URL + '/vendor_portal/sec_load_small_card_v2', {observe: 'response'});
  }

  /**
   * Get to do List
   */
  markAsDone(id) {
    return this.httpClient.put<TaskListDto[]>(ApiEndPoint.API_URL + '/common_service/sec_change_common_system_task_status', {}, {
      observe: 'response',
      params: {taskId: id}
    });
  }

  getBillTableData(searchFilterDto: TableSearchFilterDataDto) {
    return this.httpClient.post(ApiEndPoint.API_URL + '/vendor_portal/get_discount_applicable_list', searchFilterDto,
      {observe: 'response'});
  }

  getNotificationsTableData() {
    return this.httpClient.get(ApiEndPoint.API_URL + '/common_service/sec_get_notification_subscription_list_v2',
      {observe: 'response'});
  }

  notificationSubscriptionChanged(notificationUserWise) {
    return this.httpClient.put(ApiEndPoint.API_URL + '/common_service/sec_create_user_wise_notification_subscription_v2',
      notificationUserWise, {observe: 'response'});
  }

  getRolePrivileges() {
    return this.httpClient.get<any>(ApiEndPoint.API_URL + '/role_management/sec_get_portal_role_wise_authority_list_v2', {observe: 'response'}).toPromise();
  }

  getNavList() {
    return this.httpClient.get<any>(ApiEndPoint.API_URL + '/role_management/sec_view_user_nav_list', {observe: 'response'});
  }


  /////////////////////////////////////////////// Support Ticket ////////////////////////////////////////////////////

  getFeatureList() {
    return this.httpClient.get<DropdownDto[]>(ApiEndPoint.API_URL + '/common_service/sec_get_support_feature_list_v2',
      {observe: 'response'});
  }


  updateTicket(value: any) {
    return this.httpClient.post(ApiEndPoint.API_URL + '/common_service/sec_save_credit_card_for_employee',
      value, {observe: 'response', withCredentials: true});
  }

  getCategoryList() {
    return this.httpClient.get<DropdownDto[]>(ApiEndPoint.API_URL + '/common_service/sec_get_support_ticket_types_v2',
      {observe: 'response'});
  }


  downloadTicketAttachment(ticketId) {
    return this.httpClient
      .post(ApiEndPoint.API_URL + '/common_service/sec_download_support_ticket_attachment_v2', {},
        {
          params: {ticketId},
          responseType: 'blob',
          observe: 'response',
          withCredentials: true
        })
      .pipe(map(res => {
        return {
          filename: 'filename.pdf',
          result: res,
          data: new Blob([res.body], {type: 'application/zip'})
        };
      }));
  }

  getDashboardStructure() {
    // return of(
    //   {
    //     body: {
    //       templateId: 1,
    //       order: [
    //         'DASHBOARD_SHOW_DOCUMENT_PENDING_AND_REJECTED_CARDS',
    //         'DASHBOARD_SHOW_MONTHLY_BILLS_AND_PAYMENT_SUMMARY_CHART',
    //         'DASHBOARD_SHOW_MONTHLY_TRANSACTION_SUMMARY_CHART',
    //         'SHOW_BILLS_AWAITING_YOUR_APPROVAL_TABLE',
    //         'SHOW_PO_AWAITING_YOUR_APPROVAL_TABLE',
    //         'SHOW_PAYMENTS_AWAITING_YOUR_APPROVAL_TABLE',
    //         'SHOW_EXPENSES_AWAITING_YOUR_APPROVAL_TABLE'
    //       ],
    //       data: {
    //         SHOW_PO_AWAITING_YOUR_APPROVAL_TABLE: {hidden: false, gridView: false},
    //         SHOW_BILLS_AWAITING_YOUR_APPROVAL_TABLE: {hidden: false, gridView: false},
    //         SHOW_EXPENSES_AWAITING_YOUR_APPROVAL_TABLE: {hidden: false, gridView: false},
    //         SHOW_PAYMENTS_AWAITING_YOUR_APPROVAL_TABLE: {hidden: false, gridView: false},
    //         DASHBOARD_SHOW_MONTHLY_TRANSACTION_SUMMARY_CHART: {hidden: false, gridView: false},
    //         DASHBOARD_SHOW_MONTHLY_BILLS_AND_PAYMENT_SUMMARY_CHART: {hidden: false, gridView: false},
    //         DASHBOARD_SHOW_DOCUMENT_PENDING_AND_REJECTED_CARDS: {hidden: false, gridView: false},
    //       }
    //     }
    //   }
    // );

    return this.httpClient.get(ApiEndPoint.API_URL + '/common_service/sec_load_dashboard_template', {observe: 'response'});
  }

  /**
   * Get Bill Id List
   * @param fromDate
   * @param toDate
   */
  getBillIdList(fromDate, toDate){
    return this.httpClient.get(ApiEndPoint.API_URL + '/vendor_portal/sec_get_dashboard_bill_id_list', {observe: 'response', params: {fromDate, toDate}});
  }

  /**
   * Get Bill Card Data
   * @param billId
   */
  getBillCardData(billId){
    return this.httpClient.get(ApiEndPoint.API_URL + '/vendor_portal/sec_get_bill_card_detail', {observe: 'response', params: {billId}});
  }

  /**
   * Get PO Id List
   * @param fromDate
   * @param toDate
   */
  getPoIdList(fromDate, toDate){
    return this.httpClient.get(ApiEndPoint.API_URL + '/vendor_portal/sec_get_dashboard_po_id_list', {observe: 'response', params: {fromDate, toDate}});
  }

  /**
   * Get PO Card Data
   * @param poId
   */
  getPoCardData(poId){
    return this.httpClient.get(ApiEndPoint.API_URL + '/vendor_portal/sec_get_po_card_details', {observe: 'response', params: {poId}});
  }


  /**
   * Get Payments Id List
   * @param searchFilterDto
   */
  getPaymentsIdList(searchFilterDto: TableSearchFilterDataDto){
    return this.httpClient.post(ApiEndPoint.API_URL + '/vendor_portal/sec_search_dashboard_purchase_orders_v2', searchFilterDto, {observe: 'response', withCredentials: true});
  }


  /**
   * Get Expenses Id List
   * @param fromDate
   * @param toDate
   */
  getExpensesIdList(fromDate, toDate){
    return this.httpClient.get(ApiEndPoint.API_URL + '/vendor_portal/sec_get_dashboard_expense_id_list', {observe: 'response', params: {fromDate, toDate}});
  }

  /**
   * Get Expenses Card Data
   * @param expenseId
   */
  getExpensesCardData(expenseId){
    return this.httpClient.get(ApiEndPoint.API_URL + '/vendor_portal/sec_get_expense_card_details', {observe: 'response', params: {expenseId}});
  }


  /**
   * Save Dashboard Data
   * @param data
   */
  saveDashboardData(data){
    return this.httpClient.post(ApiEndPoint.API_URL + '/common_service/sec_save_dashboard_config_user_wise', data, {observe: 'response', withCredentials: true});
  }

}
